import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StreamApi } from '@app/features/app-content/models/app-config.model';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';

// static labels — 'autre' is handled via translation key
const streamTypeLabels: Record<string, string> = {
  radioking: 'RadioKing',
  shoutcast: 'Shoutcast v1',
  icecast: 'Icecast',
  indes_radios: 'Indés Radios',
  hls: 'HLS',
};

@Component({
  selector: 'rk-stream-list-item',
  templateUrl: './stream-list-item.component.html',
  styleUrl: './stream-list-item.component.scss',
  standalone: false,
})
export class StreamListItemComponent {
  @Input() stream: StreamApi;
  @Input() index = 0;
  @Input() isFirst = false;
  @Input() isLast = false;
  @Input() isLastStream = false;
  @Input() isDragging = false;
  @Input() dragDisabled = false;

  @Output() readonly edit = new EventEmitter<StreamApi>();
  @Output() readonly delete = new EventEmitter<StreamApi>();
  @Output() readonly moveToTop = new EventEmitter<StreamApi>();
  @Output() readonly moveToBottom = new EventEmitter<StreamApi>();

  constructor(private readonly translate: TranslateService) {}

  get logoUrl(): string | null {
    const logo = this.stream?.logofluxappfield;
    if (!logo) {
      return null;
    }
    if (logo.includes('data:image')) {
      return logo;
    }

    return `https://www.${environment.urls.RADIOKING_DOMAIN}/upload/applications/${logo}`;
  }

  get streamName(): string {
    return this.stream?.nomFlux || '';
  }

  get streamTypeLabel(): string {
    if (this.stream?.typeFlux === 'autre') {
      return this.translate.instant('stream-edit.other');
    }

    return streamTypeLabels[this.stream?.typeFlux] || this.stream?.typeFlux || '';
  }

  onEdit(): void {
    this.edit.emit(this.stream);
  }

  onDelete(): void {
    this.delete.emit(this.stream);
  }

  onMoveToTop(): void {
    this.moveToTop.emit(this.stream);
  }

  onMoveToBottom(): void {
    this.moveToBottom.emit(this.stream);
  }
}
